import { NutrientSource } from "@/models/NutrientSource/NutrientSource";

function normalizeAllergenLabel(value: string) {
  return (value || "").toLowerCase().replace(/[^a-z]/g, "");
}

export function formatCountrySpecificAllergenName(
  value: string,
  country?: NutrientSource | number | null
) {
  const normalized = normalizeAllergenLabel(value);

  if (normalized === "molluscs" || normalized === "mollusks") {
    return country === NutrientSource.US ? "Mollusks" : "Molluscs";
  }

  if (normalized === "sulphites" || normalized === "sulfites") {
    return country === NutrientSource.US ? "Sulfites" : "Sulphites";
  }

  return value;
}
